
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.938 0H9.188a3.817 3.817 0 00-2.785 1.23A4.346 4.346 0 005.25 4.2v33.6c0 1.114.415 2.182 1.153 2.97A3.817 3.817 0 009.188 42h23.624a3.817 3.817 0 002.785-1.23 4.346 4.346 0 001.153-2.97V10.5L24.937 0z","fill":"#7F91D2"}}),_c('path',{attrs:{"d":"M11.904 28.865l-.091-1.072.724-.041c.606-.04.91-.374.91-1v-5.177h1.306v5.166c0 1.293-.67 1.988-2.011 2.083l-.838.04zM16.33 28.773v-7.198h3.125c.79 0 1.398.197 1.827.592.43.395.643.946.643 1.654s-.214 1.263-.643 1.664c-.429.395-1.038.592-1.827.592h-1.818v2.696H16.33zm1.307-3.727h1.613c.94 0 1.41-.408 1.41-1.225 0-.81-.47-1.215-1.41-1.215h-1.613v2.44zM26.402 28.875c-.796 0-1.47-.15-2.021-.45-.545-.299-.96-.724-1.246-1.276-.286-.55-.429-1.204-.429-1.96 0-.762.147-1.42.44-1.97a3.037 3.037 0 011.265-1.287c.552-.306 1.212-.46 1.981-.46.504 0 .977.075 1.42.225.442.143.81.344 1.102.603l-.439 1.02a3.195 3.195 0 00-.98-.54 3.535 3.535 0 00-1.103-.164c-.762 0-1.34.221-1.736.664-.388.442-.582 1.079-.582 1.91 0 .836.201 1.473.603 1.908.401.436.997.654 1.787.654.224 0 .452-.017.684-.051.238-.041.473-.099.704-.174v-1.674h-1.654v-.97h2.747v3.461a5.036 5.036 0 01-1.185.388 6.624 6.624 0 01-1.358.143z","fill":"#fff"}}),_c('path',{attrs:{"d":"M24.938 0v8.5a2 2 0 002 2h9.812","fill":"#D9DFF2"}})])
          )
        }
      }
    